import { useStoreState } from "pullstate";

import { UIStore } from "@/store/UIStore";
import Recommended from "@/components/Recommended";
import { SearchCategory } from "@/helpers/pageHelpers/Store/interface";
import { RecommendedVariants } from "@/components/Recommended/Recommended.interface";

import SuggestedPodcasts from "./SuggestedPodcasts";
import SuggestedEpisodes from "./SuggestedEpisodes";
import SuggestedAuthors from "./SuggestedAuthors";

const Suggested = () => {
  const { searchCategory } = useStoreState(UIStore, (store) => store);

  switch (searchCategory) {
    case SearchCategory.Articles:
      return (
        <Recommended
          quantity={3}
          variant={RecommendedVariants.EmptyState}
          title="Polecane"
        />
      );
    case SearchCategory.Podcasts:
      return <SuggestedPodcasts />;
    case SearchCategory.Episodes:
      return <SuggestedEpisodes />;
    case SearchCategory.Authors:
      return <SuggestedAuthors />;
    default:
      return <></>;
  }
};

export default Suggested;
